import React from "react";
import { Package } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const Footer: React.FC = () => {
  const { isAdmin } = useAuth();

  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white py-4 z-40">
      <div
        className="mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center space-x-8"
        style={{ maxWidth: "104rem" }}
      >
        <div className="flex items-center space-x-2">
          <Package className="h-5 w-5 text-primary-400" />
          <span className="font-serif font-bold">AuthenTrace Systems SA</span>
        </div>
        <a
          href="mailto:info@authentrace.ch"
          className="text-primary-400 hover:text-primary-300 transition-colors"
        >
          info@authentrace.ch
        </a>
        <span className="text-gray-400 text-sm">
          © {new Date().getFullYear()} All rights reserved
        </span>
        {isAdmin && (
          <span className="text-gray-500 text-xs bg-gray-800 px-2 py-1 rounded">
            v3.0.9
          </span>
        )}
      </div>
    </footer>
  );
};

export default Footer;
